var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarSettingFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.95122 8.50447L3.52772 6.86367C2.53999 5.55845 2.94655 4.9197 3.25636 4.43294L3.26164 4.42464L4.85809 3.00558C5.65632 2.163 6.76497 2.85775 7.20843 3.18296L8.93792 2.29604C8.97339 1.23174 9.83962 0.995227 10.2683 1.01001H12.1308C13.4612 0.876972 13.5942 2.10387 13.6829 2.69515L15.5455 3.44903L15.7228 3.18296C16.3614 2.68628 17.0828 2.97601 17.3636 3.18296L19.1818 5.08983C19.2882 5.87032 18.7236 6.5089 18.4279 6.73063L19.1818 8.59316C20.388 8.66411 20.8965 9.56877 21 10.0122L20.867 12.4069C20.6896 13.1164 19.8174 13.2938 19.4035 13.2938L18.5166 15.4224C19.2971 16.132 19.0783 16.9893 18.8714 17.3293L17.3193 18.7927C16.2195 19.183 15.4715 18.6301 15.235 18.3049L13.1508 19.3249V19.857C13.1863 20.5311 12.3969 20.8474 11.9978 20.9213L9.78049 20.7883C8.92905 20.5045 8.83444 19.5762 8.89357 19.1475L6.85366 18.3049L6.23282 18.704C5.41685 18.9524 4.94678 18.8075 4.81375 18.704L3.26164 17.0632C2.76497 16.1054 3.23208 15.3042 3.52772 15.0233L2.6408 13.0277C1.50554 12.9213 1.1626 12.2443 1.13304 11.9191L1 10.0122C1.03548 8.69959 2.31559 8.46012 2.95122 8.50447Z",
    fill: "#202124",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9779,
    cy: 10.9774,
    r: 3.99501,
    fill: "#D6E2FB",
    stroke: "#202124",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarSettingFilled);
export default __webpack_public_path__ + "static/media/sidebar-setting-filled.7557e7f549e00b71086f0b76749f878e.svg";
export { ForwardRef as ReactComponent };